import { render } from "./PayCard.vue?vue&type=template&id=2856e1de&ts=true"
import script from "./PayCard.vue?vue&type=script&lang=ts"
export * from "./PayCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__